import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { anonymousSignIn, onAuthStateChange } from '@/services/AuthService'
import { initializePresence, dispose as disposePresence } from '@/services/PresenceService'

export const useAuthStore = defineStore('auth', () => {
  // Reactive state
  const currentUser = ref(null)
  const isAuthenticated = ref(false)
  const isLoading = ref(true)
  const uid = computed(() => currentUser.value?.uid || null)
  
  let unsubscribe = null

  // Initialize auth state listener
  async function initialize() {
    unsubscribe = onAuthStateChange((user) => {
      currentUser.value = user
      isAuthenticated.value = !!user
      isLoading.value = false
      
      // Initialize presence when user is authenticated
      if (user?.uid) {
        initializePresence(user.uid);
      } else {
        disposePresence();
      }
    }, (error) => {
      console.error('Auth state change error:', error)
      currentUser.value = null
      isAuthenticated.value = false
      isLoading.value = false
      disposePresence();
    })
    await signInAnonymously();
  }

  // Clean up listener
  function dispose() {
    if (unsubscribe) {
      unsubscribe()
      unsubscribe = null
    }
    disposePresence();
  }

  // Actions
  async function signInAnonymously() {
    try {
      await anonymousSignIn()
    } catch (err) {
      console.error('Sign in failed:', err)
      throw err
    }
  }

  return {
    uid,
    currentUser,
    isAuthenticated,
    isLoading,
    initialize,
    dispose
  }
})
